export enum EHarvestSaleTitleType {
  PROPOSAL = 'PROPOSAL',
  DEAL = 'DEAL',
  REQUEST = 'REQUEST',
}
